/* eslint-disable import/no-named-as-default */
import FieldSummaryMap from '../containers/layers/fieldSummary/FieldSummaryMap';
import Weather from '../containers/layers/weather/WeatherMap';
import FieldSummaryPanel from '../containers/layers/fieldSummary/FieldSummaryPanel';

import HarvestMap from '../containers/layers/harvestAndPlanting/harvest/HarvestMap';
import HarvestLegend from '../containers/layers/harvestAndPlanting/harvest/HarvestLegend';
import HarvestPanel from '../containers/layers/harvestAndPlanting/harvest/HarvestPanel';

import PlantingMap from '../containers/layers/harvestAndPlanting/planting/PlantingMap';
import PlantingLegend from '../containers/layers/harvestAndPlanting/planting/PlantingLegend';
import PlantingPanel from '../containers/layers/harvestAndPlanting/planting/PlantingPanel';
import PlantingHybridPanel from '../containers/layers/harvestAndPlanting/planting/PlantingHybridPanel';

import ApplicationsMap from '../containers/layers/inSeason/ApplicationsMap';
import ApplicationsPanel from '../containers/layers/inSeason/ApplicationsPanel';
import ApplicationLegend from '../containers/layers/inSeason/ApplicationLegend';

import FHAMap from '../containers/layers/inSeason/FHAMap';
import FHAPanel from '../containers/layers/inSeason/FHAPanel';
import FHALegend from '../containers/layers/inSeason/FHALegend';

import CropWaterPanel from '../containers/layers/inSeason/CropWaterPanel';
import CropWaterMap from '../containers/layers/inSeason/CropWaterMap';
import CropWaterLegend from '../containers/layers/inSeason/CropWaterLegend';

import SoilSsurgoMap from '../containers/layers/baseLayers/soilSsurgo/SoilSsurgoMap';
import SoilSsurgoPanel from '../containers/layers/baseLayers/soilSsurgo/SoilSsurgoPanel';

import OtherImageryMap from '../containers/layers/OtherImagery/OtherImageryMap';
import OtherImageryPanel from '../containers/layers/OtherImagery/OtherImageryPanel';
import OtherImageryLegend from '../containers/layers/OtherImagery/OtherImageryLegend';

import ImportedShapefilePanel from '../containers/layers/inSeason/ImportedShapefilePanel';
import ImportedShapefileMap from '../containers/layers/inSeason/ImportedShapefileMap';

import {
  BASE_LAYERS,
  FIELD_SUMMARY,
  WEATHER,
  PLANTING,
  HARVEST,
  IN_SEASON,
  OTHER_IMAGERY,
  IMPORTED_SHAPEFILE,
} from '../constants/mapLayerIds';

export const fieldSummaryComponents = {
  mapLayerMain: FieldSummaryMap,
  panelMain: FieldSummaryPanel,
};

export const getViewComponents = (layer) => {
  switch (layer) {
    case FIELD_SUMMARY:
      return {
        mapLayer: FieldSummaryMap,
        panel: FieldSummaryPanel,
      };
    case WEATHER:
      return {
        // content replaces the map for any component you need, like weather app.
        content: Weather,
        panel: FieldSummaryPanel,
      };
    // Planting & Base Layers - Planter elevation
    case PLANTING.HYBRID:
      return {
        mapLayer: PlantingMap,
        panel: PlantingHybridPanel,
        legend: PlantingLegend,
      };
    case PLANTING.POPULATION:
    case PLANTING.DATE:
    case PLANTING.PLANTER_SPEED:
    case PLANTING.TARGET_POPULATION:
    case BASE_LAYERS.PLANTER_ELEVATION:
    case PLANTING.ORGANIC_MATTER:
    case PLANTING.UNIFORM_FURROW:
    case PLANTING.SINGULATION:
    case PLANTING.SPACING:
    case PLANTING.DOWN_FORCE:
    case PLANTING.APPLIED_DOWN_FORCE:
    case PLANTING.CEC:
    case PLANTING.FURROW_MOISTURE:
    case PLANTING.CLEAN_FURROW:
    case PLANTING.SOIL_TEMPERATURE:
      return {
        mapLayer: PlantingMap,
        panel: PlantingPanel,
        legend: PlantingLegend,
      };
    // Harvest & Base Layers - combine elevation
    case HARVEST.YIELD:
    case HARVEST.MOISTURE:
    case HARVEST.DATE:
    case HARVEST.COMBINE_SPEED:
    case BASE_LAYERS.COMBINE_ELEVATION:
      return {
        mapLayer: HarvestMap,
        panel: HarvestPanel,
        legend: HarvestLegend,
      };
    // In season
    case IN_SEASON.APPLICATIONS:
      return {
        mapLayer: ApplicationsMap,
        panel: ApplicationsPanel,
        legend: ApplicationLegend,
      };
    case IN_SEASON.FHA:
      return {
        mapLayer: FHAMap,
        panel: FHAPanel,
        legend: FHALegend,
      };
    case IN_SEASON.CROP_WATER:
      return {
        mapLayer: CropWaterMap,
        panel: CropWaterPanel,
        legend: CropWaterLegend,
      };
    // Base Layers
    case BASE_LAYERS.DRAINAGE:
    case BASE_LAYERS.SOIL_TYPE:
      return {
        mapLayer: SoilSsurgoMap,
        panel: SoilSsurgoPanel,
      };
    case OTHER_IMAGERY:
      return {
        mapLayer: OtherImageryMap,
        panel: OtherImageryPanel,
        legend: OtherImageryLegend,
      };
    case IMPORTED_SHAPEFILE:
      return {
        mapLayer: ImportedShapefileMap,
        panel: ImportedShapefilePanel,
      };
    default:
      return {
        mapLayer: FieldSummaryMap,
        panel: FieldSummaryPanel,
      };
  }
};
